import React, { Component } from "react";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/svg-arrow.css";
import "tippy.js/themes/light.css";

//history
import history from "../_Utils/History";

//Paths
import { HOME, EDIT, PROFILE, PIECHART, COFFEE } from "../_Utils/Routes";

//Assets
import Logo from "../../Assets/Logo.svg";
import Coffee from "../../Assets/coffee.svg";
import Edit from "../../Assets/edit.svg";
import Home from "../../Assets/home.svg";
import LogIn from "../../Assets/log-in.svg";
import PieChart from "../../Assets/pie-chart.svg";
import Profile from "../../Assets/user.svg";
import Setting from "../../Assets/settings.svg";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "/",
      isSetting: false,
      isOpen: false,
    };
  }

  activeTab = (path) => {
    this.setState({
      tab: path,
    });

    history.push(path);
    this.openMenuChange();
  };

  isSettingChange = () => {
    this.setState({ isSetting: !this.state.isSetting });
  };

  openMenuChange = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <>
        <div className="NavBar">
          <div className="NavBar_Logo">
            <img src={Logo} alt="Logo" />
          </div>

          <div className="NavBar_Menu">
            <Tippy content={<div>Home</div>} placement="top" theme="dark">
              <div
                className={
                  history.location.pathname === HOME
                    ? "NavBar_MenuItem active"
                    : "NavBar_MenuItem"
                }
                onClick={() => {
                  this.activeTab(HOME);
                }}
              >
                <img src={Home} alt="Home" />
              </div>
            </Tippy>

            <Tippy
              content={<div>Calculation</div>}
              placement="top"
              theme="dark"
            >
              <div
                className={
                  history.location.pathname === EDIT
                    ? "NavBar_MenuItem active"
                    : "NavBar_MenuItem"
                }
                onClick={() => {
                  this.activeTab(EDIT);
                }}
              >
                <img src={Edit} alt="Edit" />
              </div>
            </Tippy>

            <Tippy
              content={<div>User Statistics</div>}
              placement="top"
              theme="dark"
            >
              <div
                className={
                  history.location.pathname === PIECHART
                    ? "NavBar_MenuItem active"
                    : "NavBar_MenuItem"
                }
                onClick={() => {
                  this.activeTab(PIECHART);
                }}
              >
                <img src={PieChart} alt="PieChart" />
              </div>
            </Tippy>

            <Tippy
              content={<div>Food Section</div>}
              placement="top"
              theme="dark"
            >
              <div
                className={
                  history.location.pathname === COFFEE
                    ? "NavBar_MenuItem active"
                    : "NavBar_MenuItem"
                }
                onClick={() => {
                  this.activeTab(COFFEE);
                }}
              >
                <img src={Coffee} alt="Coffee" />
              </div>
            </Tippy>

            <Tippy
              content={<div>User Profile</div>}
              placement="top"
              theme="dark"
            >
              <div
                className={
                  history.location.pathname === PROFILE
                    ? "NavBar_MenuItem active"
                    : "NavBar_MenuItem"
                }
                onClick={() => {
                  this.activeTab(PROFILE);
                }}
              >
                <img src={Profile} alt="Profile" />
              </div>
            </Tippy>
          </div>

          <Tippy content={<div>Log In</div>} placement="top" theme="dark">
            <div
              className="NavBar_LogOut"
              onClick={() => {
                history.push("/Login");
                window.location.reload();
              }}
            >
              <img src={LogIn} alt="LogIn" />
            </div>
          </Tippy>
        </div>

        <div
          className={
            this.state.isSetting ? "NavBar_Setting" : "NavBar_SettingOff"
          }
        >
          <div
            className={
              this.state.isSetting
                ? "NavBar_SettingIcon"
                : "NavBar_SettingIconOff"
            }
            onClick={this.isSettingChange}
          >
            <img src={Setting} alt="Setting" />
          </div>
          <div
            className={
              this.state.isSetting
                ? "NavBar_SettingMenu"
                : "NavBar_SettingMenuOff"
            }
          >
            <div className="NavBar_SettingMenuTitle">Settings</div>
            <div className="NavBar_SettingMenuItemHolder">
              <div className="NavBar_SettingMenuItem">Terms and Conditions</div>
              <div className="NavBar_SettingMenuItem">Refund Policy</div>
              <div className="NavBar_SettingMenuItem">Copyright Claim</div>
              <div className="NavBar_SettingMenuItem">Report Bugs</div>
            </div>
          </div>
        </div>

        <div
          className={
            this.state.isOpen ? "NavBar_PhoneHolder" : "NavBar_PhoneHolderOff"
          }
        >
          <div className="NavBar_Phone">
            <div
              className="NavBar_MenuItem active"
              onClick={this.openMenuChange}
            >
              <img
                src={
                  history.location.pathname === HOME
                    ? Home
                    : history.location.pathname === EDIT
                    ? Edit
                    : history.location.pathname === PIECHART
                    ? PieChart
                    : history.location.pathname === COFFEE
                    ? Coffee
                    : history.location.pathname === PROFILE
                    ? Profile
                    : null
                }
                alt="Home"
              />
            </div>

            {this.state.isOpen ? (
              <>
                <div
                  className={
                    history.location.pathname === HOME
                      ? "NavBar_MenuItem active"
                      : "NavBar_MenuItem"
                  }
                  onClick={() => {
                    this.activeTab(HOME);
                  }}
                >
                  <img src={Home} alt="Home" />
                </div>

                <div
                  className={
                    history.location.pathname === EDIT
                      ? "NavBar_MenuItem active"
                      : "NavBar_MenuItem"
                  }
                  onClick={() => {
                    this.activeTab(EDIT);
                  }}
                >
                  <img src={Edit} alt="Edit" />
                </div>

                <div
                  className={
                    history.location.pathname === PIECHART
                      ? "NavBar_MenuItem active"
                      : "NavBar_MenuItem"
                  }
                  onClick={() => {
                    this.activeTab(PIECHART);
                  }}
                >
                  <img src={PieChart} alt="PieChart" />
                </div>

                <div
                  className={
                    history.location.pathname === COFFEE
                      ? "NavBar_MenuItem active"
                      : "NavBar_MenuItem"
                  }
                  onClick={() => {
                    this.activeTab(COFFEE);
                  }}
                >
                  <img src={Coffee} alt="Coffee" />
                </div>

                <div
                  className={
                    history.location.pathname === PROFILE
                      ? "NavBar_MenuItem active"
                      : "NavBar_MenuItem"
                  }
                  onClick={() => {
                    this.activeTab(PROFILE);
                  }}
                >
                  <img src={Profile} alt="Profile" />
                </div>

                <div className="NavBar_LogOut">
                  <img src={LogIn} alt="LogIn" />
                </div>
              </>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default NavBar;
